module.exports = __webpack_public_path__ + "img/trunk-dunk-ingredients.f2c8c20a.jpg";